// Represents different routes for response caching purposes
export enum RouteCode {
    UNASSIGNED = '',
    LANDING_PAGE = 'lp',
    LISTING_PAGE = 'lst',
    SEARCH_LISTING_PAGE = 'lsts'
}

export const RouteCodeHeader = 'X-RouteCode';
